/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Table_Column_NumberInputs */



/**
* | output |
* | --- |
* | "#" |
*
* @param {Editor_Table_Column_NumberInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_table_column_number = /** @type {((inputs?: Editor_Table_Column_NumberInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Table_Column_NumberInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("#")
	if (locale === "de") return /** @type {LocalizedString} */ ("#")
	if (locale === "it") return /** @type {LocalizedString} */ ("#")
	if (locale === "ru") return /** @type {LocalizedString} */ ("#")
	if (locale === "es") return /** @type {LocalizedString} */ ("#")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("#")
	if (locale === "ja") return /** @type {LocalizedString} */ ("#")
	if (locale === "hi") return /** @type {LocalizedString} */ ("#")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("#")
	return /** @type {LocalizedString} */ ("#")
});